import { companySchema } from '@si/types';
import { get, objectToQueryParams } from '@si/utils';
import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { queryKeys } from './queryKeys';

const emptyObject: Params = {};

const responseSchema = z.object({
  companies: z.array(companySchema),
});

interface Params {
  status?: 'active' | 'all';
  includeProjects?: boolean;
  includeUsers?: boolean;
}

export function useCompanies({
  status = 'active',
  includeProjects = false,
  includeUsers = false,
}: Params = emptyObject) {
  const url = `/companies${objectToQueryParams({ status, includeProjects, includeUsers })}`;

  const { data, error, isLoading } = useQuery({
    queryKey: queryKeys.getCompanies(status, includeProjects, includeUsers),
    queryFn: () => get({ url, schema: responseSchema }),
  });

  return {
    companies: data?.companies || [],
    error,
    isLoading,
  };
}
